import { reverse, routing } from './routing'

export const getProductLink = (
  productType: 'STANDARD' | 'COMBINED' | 'BUNDLE' | 'GIFT_CARD',
  productId: string,
) => {
  if (productType === 'COMBINED') {
    return reverse(routing.products.combined.combinedId.self, { combinedId: productId })
  }

  if (productType === 'BUNDLE') {
    return reverse(routing.products.bundle.bundleId.self, { bundleId: productId })
  }

  if (productType === 'GIFT_CARD') {
    return reverse(routing.products.giftCard.giftCardId.self, { giftCardId: productId })
  }

  return reverse(routing.products.all.product.self, { productId })
}
